import user from './iconmonstr-user-6.svg';
import chart from './iconmonstr-chart-4.svg';
import file from './iconmonstr-file-10.svg';
import pencil from './iconmonstr-pencil-9.svg';
import help from './iconmonstr-help-5.svg';
import award from './iconmonstr-award-24.svg';
import reward from './iconmonstr-reward.svg';
import gear from './iconmonstr-gear-2.svg';

export const iconMap = {
  'iconmonstr-user-6.svg': user,
  'iconmonstr-chart-4.svg': chart,
  'iconmonstr-file-10.svg': file,
  'iconmonstr-pencil-9.svg': pencil,
  'iconmonstr-help-5.svg': help,
  'iconmonstr-award-24.svg': award,
  'iconmonstr-reward.svg': reward,
  'iconmonstr-gear-2.svg': gear,
};
